import BackNextButtons from 'components/BackNextButtons';
import { getFullName } from 'components/forms/RealNameInfo';
import RevenueForm from 'components/forms/RevenueForm';
import values from 'stores/values';
import withProgressForm, { ProgressFormProps } from 'utils/withProgressForm';

const Revenue: React.FC<ProgressFormProps> = ({ onSubmit }) => {
    const customerInfo = values.getParams();
    const name = getFullName(customerInfo);

    const handleSubmit = (ev: React.FormEvent) => {
        onSubmit('../agreements', ev);
    };

    return (
        <form noValidate className="open-revenue-root" onSubmit={handleSubmit}>
            <RevenueForm name={name} customerInfo={customerInfo} />
            <BackNextButtons />
        </form>
    );
};

export default withProgressForm({
    step: 5,
    id: 'revenue',
    cache: false,
    ensure: 'baseinfo',
    basePath: 'esop'
})(Revenue);
